<template>
    <div class="equipment-detail">
        <!-- banner -->
        <mall-banner
            router-name="化妆品专区入口"
            router-path="/cosmetics">
        </mall-banner>
        <!-- 内容部分 -->
        <div class="container">
            <!-- 简介 -->
            <div class="equipment-detail-brief">
                <!-- 图片 -->
                <div class="equipment-detail-brief-pic">
                    <detail-pic></detail-pic>
                </div>
                <!-- 表单 -->
                <div class="equipment-detail-brief-form">
                    <detail-form></detail-form>
                </div>
            </div>
            <!-- 标签页 -->
            <div class="equipment-detail-tab">
                <!-- 标签列表 -->
                <div class="equipment-detail-tab-list">
                    <a href="javascript:;"
                        v-for="item in tabs_list"
                        :key="item.id"
                        @click="handleTabs(item.value)"
                        :class="{
                            'selected-tab': componentId == item.value
                        }">
                        {{item.label}}
                    </a>
                </div>
                <!-- 标签视图 -->
                <div class="equipment-detail-tab-view">
                    <component :is="componentId"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                componentId: "detailTabComment",
                tabs_list: [
                    {
                        value: "detailTabDetail",
                        label: "商品详情",
                    },
                    {
                        value: "detailTabComment",
                        label: "评论",
                    }
                ]
            }
        },
        components: {
            mallBanner: () => import("@/components/imageMall/mallBanner"),
            detailPic: () => import("@/components/imageMall/detailPic"),
            detailForm: () => import("@/components/imageMall/detailForm"),
            detailTabDetail: () => import("@/components/imageMall/detailTabDetail"),
            detailTabComment: () => import("@/components/imageMall/detailTabComment"),
        },
        methods: {
            handleTabs(val){
                this.componentId = val;
            }
        },
    }
</script>

<style scoped>
.equipment-detail{
    --color: #8d9afc;
    --color2: #e7e9fe;
    --color3: #8da1fc;
    padding-bottom: 50px;
    background-color: #fafafa;
}
/* 简介 */
.equipment-detail-brief{
    display: flex;
    align-items: stretch;
    margin-top: 30px;
    background-color: #fff;
    border-radius: 6px;
}
/* 图片 */
.equipment-detail-brief-pic{
    width: 40%;
    flex-shrink: 0;
}
/* 表单 */
.equipment-detail-brief-form{
    flex: 1 1;
}

/* 标签页 */
.equipment-detail-tab{
    margin-top: 30px;
}
/* 标签列表 */
.equipment-detail-tab-list > a{
    display: inline-block;
    vertical-align: middle;
    width: 140px;
    margin-left: 10px;
    padding: 10px 0;
    background-color: #8d9afc;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    text-align: center;
    letter-spacing: 2px;
    font-size: 16px;
    color: #fff;
}
.equipment-detail-tab-list > a.selected-tab{
    background-color: #fff;
    color: #8d9afc;
}
/* 标签视图 */
.equipment-detail-tab-view{
    padding: 20px;
    background-color: #fff;
    border-radius: 6px;
}
</style>